import { t } from '@/core/localization';
export function getUnitLabel(type) {
    switch (type) {
        case 'currency': {
            return t('$');
        }
        case 'percent': {
            return '%';
        }
        case 'pieces': {
            return t('pieces.abbr');
        }
        case 'days': {
            return t('days.abbr');
        }
        case 'weight': {
            return t('weight.kg.abbr');
        }
        case 'length': {
            return t('length.meter.abbr');
        }
        default: {
            throw new Error(`Unhandled NumericFieldUnit case: ${type}`);
        }
    }
}
